"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import s from "react";
const f = s.forwardRef(function(t, e) {
  const { className: o, component: n = "div", ...r } = t;
  return /* @__PURE__ */ a.jsx(n, { ref: e, className: o, ...r });
});
export {
  f as TableContainer
};
